import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import t from '../../lib/I18n';
import Icon from '../general/Icon';
import Button from 'react-bootstrap/lib/Button';

class LoginModalFooter extends React.PureComponent {
    render() {
        const { handleLogin, nextButtonActive, handleRegister } = this.props;
        return (<React.Fragment>
            <button
                className={classnames('action-btn action-btn--primary modal__footer__button modal__footer__button--primary', { 'modal__footer__button--inactive': !nextButtonActive }) }
                onClick={handleLogin}
            >
                <Icon icon="chevronslim" className="modal__footer__button__arrow" />
                <span className="modal__footer__button__text">{t('account.login')}</span>
            </button>

            <p className="text-center text-weight--bold margin-top--sm margin-bottom">
                {t('account.login.registerLabel')}{' '}
                <Button onClick={handleRegister} className="like-link modal__footer__link">
                    {t('account.register')}
                </Button>
            </p>
        </React.Fragment>);
    }
}

LoginModalFooter.propTypes = {
    handleLogin: PropTypes.func,
    handleRegister: PropTypes.func,
    nextButtonActive: PropTypes.bool,
};

export default LoginModalFooter;



// WEBPACK FOOTER //
// ./src/components/login/LoginModalFooter.js